<div class="vertical-page medical-societies-page">
  <section class="hero-section">
    <div class="container">
      <div class="row align-items-center g-4 g-lg-5">
        <div class="col-lg-6 order-2 order-lg-1">
          <a routerLink="/communities" class="back-link mb-3">
            <mat-icon>arrow_back</mat-icon> Communities
          </a>
          <h1 class="headline mt-primary-text mb-3">Membership software for medical and surgical societies</h1>
          <p class="subheadline mt-primary-text mb-4">
            Run membership renewals, annual meetings, CME events, and member directories in one platform built for medical and surgical societies. Members use the web or the <a routerLink="/mobile" class="inline-link">MemberTrace app</a>—one download for them, even when they belong to more than one society.
          </p>
          <div class="cta-buttons">
            <button mat-flat-button color="primary" routerLink="/contact" [queryParams]="{ inquiryType: 'demo' }">Talk to our team</button>
            <button mat-stroked-button color="primary" routerLink="/pricing">See pricing</button>
          </div>
        </div>
        <div class="col-lg-6 order-1 order-lg-2">
          <div class="hero-image-wrap">
            <img src="/img/medical-hero.webp" alt="Medical and surgical society membership management" class="hero-image" />
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="features-section py-5">
    <div class="container">
      <h2 class="section-title text-center mb-5">Everything medical and surgical societies need to operate and grow</h2>
      <div class="row g-4">
        <div class="col-md-6 col-lg-4" *ngFor="let feature of features">
          <div class="feature-item">
            <mat-icon color="primary" class="feature-icon">{{ feature.icon }}</mat-icon>
            <h3 class="feature-title">{{ feature.title }}</h3>
            <p class="feature-description">{{ feature.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="social-proof-section py-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 mx-auto text-center">
          <h2 class="section-title mb-4">Trusted by medical societies nationwide</h2>
          <p class="section-intro mb-4">
            MemberTrace powers leading surgical and physician societies, including:
          </p>
          <ul class="examples-list">
            <li *ngFor="let example of examples">{{ example }}</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="cta-section py-5">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center">
          <h2 class="cta-title mb-3">Ready to streamline your society?</h2>
          <p class="cta-subtitle mb-4">
            Join other medical and surgical societies using MemberTrace for membership, events, and member engagement.
          </p>
          <div class="cta-buttons d-flex flex-wrap gap-3 justify-content-center">
            <button mat-flat-button color="primary" routerLink="/contact">Talk to our team</button>
            <button mat-stroked-button color="primary" routerLink="/pricing">See pricing</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
